import { render, staticRenderFns } from "./lotteryGift.vue?vue&type=template&id=48c49ada&scoped=true&"
import script from "./lotteryGift.vue?vue&type=script&lang=js&"
export * from "./lotteryGift.vue?vue&type=script&lang=js&"
import style0 from "./lotteryGift.vue?vue&type=style&index=0&id=48c49ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c49ada",
  null
  
)

export default component.exports